import { render, staticRenderFns } from "./Widget12.vue?vue&type=template&id=159422a6"
import script from "./Widget12.vue?vue&type=script&lang=js"
export * from "./Widget12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports